<template>
  <div class="row">
    <div class="mx-auto col-md-12">
      <div class="card p-3 mb-3">
        <div class="card-body">
          <b-card class="mb-3" header="Relatório Beneficiários sem Conta">
            <b-card no-body>
              <b-card-header size="sm">
                <div class="float-right">
                  <b-button
                    variant="primary"
                    @click.prevent="gerarRelatorio"
                    title="Gerar Relatório"
                  >
                    <font-awesome-icon
                      :icon="['fas', 'file-pdf']"
                      title="Gerar Relatório"
                      class="mr-1"
                    />
                    Gerar Relatório
                  </b-button>
                </div>
              </b-card-header>
              <b-table
                no-provider-paging
                small
                responsive
                bordered
                :empty-text="tabela.emptyText"
                :fields="tabela.fields"
                :items="tabela.items"
                :show-empty="tabela.showEmpty"
                :striped="tabela.striped"
              >
                <template v-slot:cell(data_nascimento)="data">
                  {{ $helpers.formatDateHourToDate(data.value) }}
                </template>
              </b-table>
              <b-card-footer size="sm">
                <div class="float-left">
                  <b-input-group prepend="Quantidade de Registros">
                    <b-input
                      disabled
                      v-model="parametros.paginacao.total"
                    ></b-input>
                  </b-input-group>
                </div>
                <div class="float-right">
                  <b-pagination
                    align="right"
                    :total-rows="parametros.paginacao.total"
                    v-model="parametros.paginacao.current_page"
                    :per-page="parametros.paginacao.per_page"
                    @change="changePaginacao"
                  >
                  </b-pagination>
                </div>
              </b-card-footer>
            </b-card>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Paginacao from "../../../models/Paginacao";

export default {
  data() {
    return {
      parametros: {
        paginacao: new Paginacao(),
      },
      tabela: {
        items: [],
        fields: [
          {
            key: "cpf_requerente",
            label: "CPF",
            class: "text-center",
          },
          {
            key: "nome_completo",
            label: "Nome completo",
            class: "text-center",
          },
          {
            key: "nome_mae",
            label: "Nome da mãe",
            class: "text-center",
          },
          {
            key: "data_nascimento",
            label: "Data Nascimento",
            class: "text-center",
          },
        ],
        showEmpty: true,
        emptyText: "Nenhum registro encontrado",
        striped: true,
      },
    };
  },

  methods: {
    changePaginacao() {
      this.listar();
    },

    listar() {
      this.$api
        .get(`familias/beneficiarios-sem-conta`, { params: this.parametros })
        .then((response) => {
          if (response.status == 200) {
            this.parametros.paginacao = new Paginacao(response.data.dados);
            this.tabela.items = response.data.dados.data;
          }
        })
        .catch((error) => {
          if (error.response.data) {
            this.$helpers.showToast(
              this,
              "Erro",
              error.response.data.message,
              "danger"
            );
          }
        });
    },

    gerarRelatorio() {
      this.$api
        .get(`familias/relatorio/beneficiarios-sem-conta`, {
          responseType: "blob",
        })
        .then((response) => {
          this.$helpers.downloadFile(
            response.data,
            "beneficiarios-sem-conta.pdf"
          );
          this.$helpers.showToast(
            this,
            "Sucesso",
            "Relatório gerado com sucesso.",
            "success"
          );
        })
        .catch(() => {
          this.$helpers.showToast(
            this,
            "Erro",
            "Erro na geração do relatório",
            "danger"
          );
        });
    },
  },

  mounted() {
    this.listar();
  },
};
</script>

<style scoped>
</style>
